import { render, staticRenderFns } from "./CardShowDetails.vue?vue&type=template&id=60ea0a0b"
import script from "./CardShowDetails.vue?vue&type=script&lang=js"
export * from "./CardShowDetails.vue?vue&type=script&lang=js"
import style0 from "./CardShowDetails.vue?vue&type=style&index=0&id=60ea0a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports